import { formatSnapshotValue } from './snapshotDisplay';

/**
 * Renders one side of a diffed field for display. Raw ISO date/date-time leaves (e.g. an expiry or
 * issue date) are reformatted to a human date via `formatSnapshotValue`; everything else passes
 * through. Empty/null renders as an em dash.
 */
export const formatDiffValue = (value: string | null | undefined): string =>
  value === null || value === undefined || value === ''
    ? '—'
    : formatSnapshotValue(value);

/**
 * Masks a sensitive value to its last 4 characters (e.g. "•••• 3210"), matching the approved-snapshot
 * design mock. This is a deliberate re-open of design revision R7 (which had cut masking): sensitive
 * fields are masked by default and the buyer reveals the full value with a per-row toggle. Applied on
 * every surface that renders a diffed value — a bank account number does not stop being sensitive
 * once the change carrying it has been approved.
 */
export const maskDiffValue = (value: string | null | undefined): string => {
  const formatted = formatDiffValue(value);
  if (formatted === '—') {
    return formatted;
  }
  const trimmed = formatted.trim();
  const last4 = trimmed.length > 4 ? trimmed.slice(-4) : '';
  return last4 ? `•••• ${last4}` : '••••';
};
